export default __webpack_public_path__ + "static/hex-ab5d602db9e18f820b51e959eb0b979a.png";